import { combineTokens } from '@utils/css';

const sizeTransitionTokens = combineTokens("--size-transition", {
  initialHeight: "0px",
  initialWidth: "0px"
});

export { sizeTransitionTokens };
//# sourceMappingURL=transition.size.selectors.js.map
